/**
 * Hard cap on a single menu item's AGGREGATE quantity — SUM(quantity) across every
 * cart line sharing the same menu_item_id (regardless of modifier/combo configuration)
 * — within one order. Enforced client-side (UX) and authoritatively server-side.
 */
export const MAX_MENU_ITEM_QUANTITY = 50

/** Hard cap for a single modifier row's quantity (per parent unit). Unrelated to menu-item quantity. */
export const MAX_MODIFIER_QUANTITY = 100
